import PropTypes from "prop-types";

const Video = {
	isVisible: PropTypes.bool,
};

export default {
	Video,
};
